import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Button,
  Box,
  Typography,
  IconButton,
  Grid,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import style from "./Invoice.module.scss";
import FormGroup from "@mui/material/FormGroup";

import {
  getinvoiceCandidate,
  postInvoiceCandidates,
  PutinvoiceInterviewUpdate,
  putUpdateInterviews,
  UpdatejoiningDayPipelineStatus,
} from "../../../apiServices";
import {
  capitalizeWords,
  dateFormate,
  dateFormateDD,
  formatAmountCalculate,
  MyModal,
  textTruncate,
} from "../../../utility";
import { TiTick } from "react-icons/ti";
import ModalContainer from "../../../components/modal_popup";
import SuccessTick from "../../../components/success_tick";
import { BsPencilFill } from "react-icons/bs";
import { BiPencil } from "react-icons/bi";
import { FaRegSave } from "react-icons/fa";
import { useFetcher } from "react-router-dom";
import Document from "../../invoceDoc/Document";
import { AiOutlineClose } from "react-icons/ai";

function InvoicePostForm({ onClose, employerId }) {
  const empId = employerId;
  // console.log(empId, "empId");

  const [step, setStep] = useState(1);
  const documentRef = useRef(null);
  const [invoiceNumber, setInvoiceNumber] = useState();
  // const [checkedCandidate, setCheckedCandidate] = useState(true);
  const [formData, setFormData] = useState({
    invoiceDate: new Date().toISOString().split("T")[0],
    invoiceNumber: "",
    dueDateFrom: "",
    dueDateTo: "",
    actualAmount: "",
    cgst:"",
    sgst:"",
    gst: "",
    totalAmount: "",
    roundOfAmount: "",
    balanceDue: "",
    candidates: [
      {
        id: "",
        name: "",
        ctc: "",
        category: "",
        joined: "",
        candidateId: "",
        employeeId: "",
        department: "",
        checked: true,
      },
    ],
  });
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [openPreview, setOpenPreview] = useState(false);
  const [openActualCtcupdate, setopenActualCtcupdate] = useState(false);
  const [successTick, setsuccessTick] = useState({
    save: false,
    create: false,
  });
  const [openConfirmation, setopenConfirmation] = useState({
    save: false,
    create: false,
  });
  const [showField, setShowField] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [storeInvoiceCandidateList, setStoreInvoiceCandidateList] = useState(
    []
  );
  const [changeCandidateList, setchangeCandidateList] = useState();
  const [getnameAndId, setGetnameAndId] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  const [visibleFields, setVisibleFields] = useState({
    employeeId: false,
    department: false,
  });

  const handleFieldToggle = (field) => {
    setVisibleFields((prev) => {
      const updatedFields = {
        ...prev,
        [field]: !prev[field],
      };
      return updatedFields;
    });
  };

  useEffect(() => {
    if (visibleFields.department || visibleFields.employeeId) {
      setIsEditing(true);
    }
  }, [visibleFields]);
  const validateForm = () => {
    const newErrors = {};
    let hasValidationError = false; // Track if any error exists

    formData.candidates
      .filter((candidate) => candidate.checked)
      .forEach((candidate) => {
        const candidateErrors = {};

        if (candidate.ctc === null || isNaN(candidate.ctc)) {
          candidateErrors.ctc = "CTC is required";
        }
        if (!candidate.category) {
          candidateErrors.category = "Job category is required.";
        }
        if (!candidate.joined) {
          candidateErrors.joined = "Joined Date is required.";
        }
        // if (visibleFields.employeeId && !candidate.employeeId)
        //   candidateErrors.employeeId = "Employee ID is required.";
        // if (visibleFields.department && !candidate.department)
        //   candidateErrors.department = "Department is required.";

        if (Object.keys(candidateErrors).length > 0) {
          newErrors[candidate.id] = candidateErrors;
          hasValidationError = true; // At least one candidate has an error
        }
      });

    setErrors(newErrors);
    setIsEditing(hasValidationError); // ✅ Set isEditing true if any field is empty
    return newErrors;
  };

  const toggleEdit = () => {
    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      return;
    }
    // Proceed with toggling edit or save confirmation
    if (isEditing) {
      handleSaveConfirmation();
    } else {
      setIsEditing(!isEditing);
    }
  };
  useEffect(() => {
    if (step === 1) {
      const isStep1Valid = validateStep1(false);
      setIsButtonDisabled(!isStep1Valid);
    } else if (step === 2) {
      const allCtcPresent = formData.candidates.some(
        (candidate) => candidate.ctc && !isNaN(parseFloat(candidate.ctc))
      );
      // console.log(allCtcPresent, "allCtcPresent");

      if (allCtcPresent) {
        const { actualAmount,cgst, sgst, gst, totalAmount, roundOfAmount, balanceDue } =
          calculateAmounts(formData.candidates);

        setFormData((prevData) => ({
          ...prevData,
          actualAmount,
          cgst, 
          sgst,
          gst,
          totalAmount,
          roundOfAmount,
          balanceDue,
        }));
      }

      const isStep2Valid = validateStep2(false);
      setIsButtonDisabled(!isStep2Valid || !allCtcPresent);
    }
    // console.log(formData, "forr");
  }, [formData, step]);
  function handleSaveConfirmation() {
    setIsEditing(true);
    setopenConfirmation({
      save: true,
    });
  }
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeCheckBox = (event, index) => {
    setFormData((prev) => {
      const updatedCandidates = [...prev.candidates];
      updatedCandidates[index].checked = event.target.checked;
      return {
        ...prev,
        candidates: updatedCandidates,
      };
    });
  };
  useEffect(() => {
    // console.log("kkk");
  }, [formData.candidates]);
  const calculateAmounts = (candidates) => {
    // Calculate actual amount
    let checkedCandidates = candidates.filter((candidate) => candidate.checked);
    if (checkedCandidates.length === 0) {
      return {
        actualAmount: 0,
        cgst:0, 
        sgst:0,
        gst: 0,
        totalAmount: 0,
        roundOfAmount: "0.00",
        balanceDue: "0.00",
      };
    }

    const actual = checkedCandidates.reduce(
      (sum, candidate) => sum + (parseFloat(candidate.ctc) || 0),
      0
    );

    const gstAmount = actual * 0.18;
    const cgstAmount = actual * 0.09;
    const sgstAmount = actual * 0.09;
    const totalAmount = actual + gstAmount;

    // Calculate roundOfAmount and balanceDue
    const roundOfAmount = (totalAmount % 1).toFixed(2); // Fractional part
    const balanceDue = Math.floor(totalAmount).toFixed(2); // Whole part

    return {
      actualAmount: actual,
      cgst: cgstAmount,
      sgst: sgstAmount,
      gst: gstAmount,
      totalAmount,
      roundOfAmount,
      balanceDue,
    };
  };

  const handleCtcChange = (name, id, value) => {
    const updatedCandidates = formData.candidates.map((candidate) =>
      candidate.id === id ? { ...candidate, [name]: value } : candidate
    );

    const { actualAmount,cgst,sgst, gst, totalAmount, roundOfAmount, balanceDue } =
      calculateAmounts(updatedCandidates);

    setFormData((prevData) => ({
      ...prevData,
      candidates: updatedCandidates,
      actualAmount,
      cgst,
      sgst,
      gst,
      totalAmount,
      roundOfAmount,
      balanceDue,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [id]: {
        ...prevErrors[id],
        [name]: "",
      },
    }));
  };

  useEffect(() => {
    const updatedCandidates = storeInvoiceCandidateList.map((candidate) => {
      const matchingCandidate = formData.candidates.find(
        (el) => el.id === candidate.id
      );

      if (matchingCandidate) {
        return {
          ...candidate,
          checked: matchingCandidate.checked ?? false,
          ctc: matchingCandidate.ctc,
          job_category: matchingCandidate.category,
          joined_on: matchingCandidate.joined,
          employee_id: matchingCandidate.employeeId,
          department: matchingCandidate.department,
        };
      }

      return { ...candidate, checked: candidate.checked ?? false };
    });
    let filteredCandidates = updatedCandidates.filter(
      (c) => c.checked === true
    );

    // console.log(filteredCandidates, "lll", updatedCandidates);

    setchangeCandidateList(filteredCandidates);
  }, [formData, storeInvoiceCandidateList]);

  const validateStep1 = (setErrorMessages = true) => {
    const newErrors = {};

    if (!formData.dueDateFrom) {
      newErrors.dueDateFrom = "Due Date From is required.";
    }
    if (!formData.dueDateTo) {
      newErrors.dueDateTo = "Due Date To is required.";
    }

    // if (!formData.invoiceNumber) {
    //   newErrors.invoiceNumber = "Invoice Number is required.";
    // }
    if (setErrorMessages) setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = async () => {
    // setEnableSubmit(true);
    try {
      const formObject = {
        startDate: formData.dueDateFrom,
        endDate: formData.dueDateTo,
        empId: employerId,
      };

      const data = await getinvoiceCandidate(formObject);
      const stroreData = data.result.map((el) => el);
      setStoreInvoiceCandidateList(stroreData);

      const candidates = data.result.map((el) => ({
        id: el.id,
        name: `${el.first_name} ${el.last_name || ""}`.trim(),
        ctc: el.ctc,
        category: el.job_category,
        joined: el.joined_on ? el.joined_on.split("T")[0] : "",
        candidateId: el.can_id,
        checked: true,
      }));

      setFormData((prevData) => ({
        ...prevData,
        candidates,
      }));
      // setTimeout(() => {
      //   setEnableSubmit(false);
      // }, 3000);
      setStep(2);
    } catch (error) {
      console.error("Error fetching invoice candidate data:", error);
    }
  };
  const validateStep2 = (setErrorMessages = true) => {
    const newErrors = {};

    // Ensure candidates array is defined before proceeding
    if (formData?.candidates?.length > 0) {
      formData.candidates
        .filter((candidate) => candidate.checked)
        .forEach((candidate) => {
          const candidateErrors = {};

          if (!candidate.ctc) {
            candidateErrors.ctc = "CTC is required.";
          }

          if (!candidate.category) {
            candidateErrors.category = "Job category is required.";
          }
          if (!candidate.joined) {
            candidateErrors.joined = "Joined Date is required.";
          }

          if (Object.keys(candidateErrors).length > 0) {
            newErrors[candidate.id] = candidateErrors;
          }
        });
    }
    if (!formData.invoiceDate) {
      newErrors.invoiceDate = "Invoice Date is required.";
    }

    if (setErrorMessages) setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Save function
  const handleSave = () => {
    const obj = formData.candidates;
    setEnableSubmit(true);
    // Call the update function
    setsuccessTick({
      save: true,
    });

    putUpdateInterviews(obj).then((data) => console.log(data, "data"));
    setTimeout(() => {
      setsuccessTick({
        save: false,
      });
      setEnableSubmit(false);
      setopenConfirmation({
        save: false,
      });
      setIsEditing(false);
    }, 3000);
    console.log("Updated Candidates Data:", formData.candidates);
  };

  const handleBack = () => {
    setStep(1);
    setErrors({});
  };

  const closeForm = () => {
    setFormData({
      invoiceDate: "",
      invoiceNumber: "",
      dueDateFrom: "",
      dueDateTo: "",
    });
    onClose();
  };
  function handleConfirmationSubmit() {
    if (validateStep2()) {
      setopenConfirmation({
        create: true,
      });
    } else {
      setIsEditing(true);
    }
  }
  const handleSubmit = async () => {
    if (validateStep2()) {
      setEnableSubmit(true);

      const object1 = {
        invoice_date: formData.invoiceDate,
        actual_amount: formData.actualAmount,
        // cgst_amount: formData.cgst,
        // sgst_amount: formData.sgst,
        gst_amount: formData.gst,
        total_amount: formData.totalAmount,
        emp_id: empId,
        start_period: formData.dueDateFrom,
        end_period: formData.dueDateTo,
      };
      const object2 = changeCandidateList;

      setsuccessTick({ create: true });

      try {
        const response = await postInvoiceCandidates(object1, object2);
        console.log(response, "API Response");
        if (response?.message === "successfully created") {
          const invoiceNo = response.data?.invoice_no; // Extracting invoice_no
          // console.log(invoiceNo, "Invoice Number");

          // Use the invoiceNo as needed
          setInvoiceNumber(invoiceNo); // Assuming setInvoiceNumber saves the invoice number

          // if (invoiceNumber && documentRef.current) {
          //   documentRef.current.generatePDF();
          // }
        } else {
          alert("somthing went wrong");
          console.error("Unexpected response:", response);
          throw new Error("Invoice creation failed");
        }
      } catch (error) {
        console.error("Error in handleSubmit:", error);
      } finally {
        setTimeout(() => {
          setsuccessTick({ create: false });
          setEnableSubmit(false);
          closeForm();
        }, 3000);
      }
    }
  };
  useEffect(() => {
    // console.log(invoiceNumber, "hi");

    if (invoiceNumber !== "" && documentRef.current) {
      documentRef.current.generatePDF({ invoiceNumber });
    }
  }, [invoiceNumber]);

  const handlePreviewOpen = () => {
    const newErrors = validateForm();

    if (!formData.candidates.some((e) => e.checked)) {
      // If at least one candidate is checked, proceed with preview
      setOpenPreview(false);
      return;
    }

    if (Object.keys(newErrors).length === 0) {
      setOpenPreview(true);
    } else {
      setOpenPreview(false);
      console.log("Form validation failed:", newErrors);
    }
  };

  return (
    <>
      <div className={`${style.Box}`}>
        <div>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Typography variant="h6">
                <b>Create Invoice</b>
              </Typography>
            </div>
            <div className="d-flex align-items-center gap-2">
              {step === 2 && (
                <>
                  <div>
                    <button
                      className={`${style.editCandidateList}`}
                      onClick={toggleEdit}
                    >
                      {isEditing ? (
                        <span>
                          Save <FaRegSave />
                        </span>
                      ) : (
                        <span>
                          Edit <BiPencil />
                        </span>
                      )}
                    </button>
                  </div>
                  <div>
                    <button
                      className={`${style.AddField}`}
                      onClick={() => {
                        setShowField(true);
                      }}
                    >
                      Add Field
                    </button>
                  </div>
                </>
              )}
              <div>
                <Tooltip title={"Close"} arrow placement="top">
                  <IconButton onClick={() => closeForm()}>
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </Box>
          {step === 2 && (
            <>
              <div
                className={`${
                  isEditing ? style.joinedCandidateContainer : style.step2Width
                }`}
              >
                {formData?.candidates?.length > 0 ? (
                  <div
                    className={`${
                      isEditing
                        ? style.joinedCandidateContainer
                        : style.step2Width
                    }`}
                  >
                    <Grid
                      container
                      spacing={2}
                      className="container-fluid mt-3"
                    >
                      <Grid
                        item
                        xs={
                          visibleFields.employeeId || visibleFields.department
                            ? 2
                            : 3
                        }
                      >
                        <b>Candidate</b>
                      </Grid>
                      <Grid
                        item
                        xs={
                          visibleFields.employeeId || visibleFields.department
                            ? 2
                            : 3
                        }
                      >
                        <b>Job Category</b>
                      </Grid>
                      <Grid
                        item
                        xs={
                          visibleFields.employeeId || visibleFields.department
                            ? 2
                            : 3
                        }
                      >
                        <b>Joined Date</b>
                      </Grid>
                      <Grid
                        item
                        xs={
                          visibleFields.employeeId || visibleFields.department
                            ? 2
                            : 3
                        }
                      >
                        <b>Salary</b>
                      </Grid>
                      {visibleFields.employeeId && (
                        <Grid
                          item
                          xs={
                            visibleFields.employeeId || visibleFields.department
                              ? 2
                              : 3
                          }
                        >
                          <b>Employee ID</b>
                        </Grid>
                      )}
                      {visibleFields.department && (
                        <Grid
                          item
                          xs={
                            visibleFields.employeeId || visibleFields.department
                              ? 2
                              : 3
                          }
                        >
                          <b>Department</b>
                        </Grid>
                      )}
                    </Grid>

                    <div className={`container-fluid ${style.step2}`}>
                      {formData.candidates.map((candidate, index) => (
                        <Grid
                          container
                          key={index}
                          spacing={2}
                          className="mt-2 d-flex align-items-center"
                        >
                          <Grid
                            item
                            xs={
                              visibleFields.employeeId ||
                              visibleFields.department
                                ? 2
                                : 3
                            }
                            className="d-flex align-items-center gap-2"
                          >
                            <div>
                              <Checkbox
                                checked={candidate.checked}
                                onChange={(e) => {
                                  handleChangeCheckBox(e, index);
                                }}
                                inputProps={{ "aria-label": "controlled" }}
                                label={<b>{index + 1}</b>}
                              />
                            </div>
                            <div>
                              {/* {candidate.name} */}
                              {candidate.name != null
                                ? textTruncate(
                                    capitalizeWords(candidate.name),
                                    15
                                  )
                                : "-"}
                            </div>
                            {/* {isEditing ? (
                              <input
                                type="text"
                                value={candidate.name || ""}
                                onChange={(e) =>
                                  handleCtcChange(
                                    "name",
                                    candidate.id,
                                    e.target.value
                                  )
                                }
                                readOnly
                                className={`ms-1 ${style["custom-input1"]}`}
                              />
                            ) : (
                              candidate.name || "-"
                            )} */}
                          </Grid>
                          <Grid
                            item
                            xs={
                              visibleFields.employeeId ||
                              visibleFields.department
                                ? 2
                                : 3
                            }
                          >
                            {isEditing ? (
                              <>
                                <input
                                  type="text"
                                  value={candidate.category || ""}
                                  onChange={(e) =>
                                    handleCtcChange(
                                      "category",
                                      candidate.id,
                                      e.target.value
                                    )
                                  }
                                  onKeyPress={(e) => {
                                    if (!/^[A-Za-z\s]*$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  className={style["custom-input"]}
                                />
                                {errors[candidate.id]?.category && (
                                  <div
                                    className="text-danger"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {errors[candidate.id].category}
                                  </div>
                                )}
                              </>
                            ) : (
                              candidate.category || "-"
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={
                              visibleFields.employeeId ||
                              visibleFields.department
                                ? 2
                                : 3
                            }
                          >
                            {isEditing ? (
                              <>
                                <input
                                  type="date"
                                  value={candidate.joined || ""}
                                  onChange={(e) =>
                                    handleCtcChange(
                                      "joined",
                                      candidate.id,
                                      e.target.value
                                    )
                                  }
                                  className={style["custom-input"]}
                                />
                                {errors[candidate.id]?.joined && (
                                  <div
                                    className="text-danger"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {errors[candidate.id].joined}
                                  </div>
                                )}
                              </>
                            ) : (
                              dateFormateDD(candidate.joined) || "-"
                            )}
                          </Grid>
                          <Grid
                            item
                            xs={
                              visibleFields.employeeId ||
                              visibleFields.department
                                ? 2
                                : 3
                            }
                          >
                            {isEditing ? (
                              <>
                                {" "}
                                <input
                                  type="text"
                                  value={candidate.ctc || ""}
                                  onChange={(e) =>
                                    handleCtcChange(
                                      "ctc",
                                      candidate.id,
                                      e.target.value
                                    )
                                  }
                                  maxLength={7}
                                  onKeyPress={(e) => {
                                    if (!/^\d*$/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  className={style["custom-input"]}
                                />
                                {errors[candidate.id]?.ctc && (
                                  <div
                                    className="text-danger"
                                    style={{ fontSize: "13px" }}
                                  >
                                    {errors[candidate.id].ctc}
                                  </div>
                                )}
                              </>
                            ) : candidate.ctc != null ? (
                              formatAmountCalculate(candidate.ctc)
                            ) : (
                              "-"
                            )}
                          </Grid>
                          {visibleFields.employeeId && (
                            <Grid
                              item
                              xs={
                                visibleFields.employeeId ||
                                visibleFields.department
                                  ? 2
                                  : 3
                              }
                            >
                              {isEditing ? (
                                <input
                                  type="text"
                                  value={candidate.employeeId || ""}
                                  onChange={(e) =>
                                    handleCtcChange(
                                      "employeeId",
                                      candidate.id,
                                      e.target.value
                                    )
                                  }
                                  className={style["custom-input"]}
                                />
                              ) : (
                                candidate.employeeId || "-"
                              )}
                            </Grid>
                          )}
                          {visibleFields.department && (
                            <Grid
                              item
                              xs={
                                visibleFields.employeeId ||
                                visibleFields.department
                                  ? 2
                                  : 3
                              }
                            >
                              {isEditing ? (
                                <input
                                  type="text"
                                  value={candidate.department || ""}
                                  onChange={(e) =>
                                    handleCtcChange(
                                      "department",
                                      candidate.id,
                                      e.target.value
                                    )
                                  }
                                  className={style["custom-input"]}
                                />
                              ) : (
                                candidate.department || "-"
                              )}
                            </Grid>
                          )}
                        </Grid>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center text-danger mt-5">
                    No candidates available
                  </div>
                )}
              </div>
              <div className="mt-2">
                <div className="col-sm-12">
                  <TextField
                    label="Invoice Date"
                    name="invoiceDate"
                    type="date"
                    value={formData.invoiceDate}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.invoiceDate}
                    helperText={errors.invoiceDate}
                    // defaultValue={new Date()}
                  />
                </div>
              </div>

              <div className={`mt-2   ${style.paragraph}`}>
                <div className="row">
                  <div className="col-sm-6"></div>
                  <div className="col-sm-2">
                    <div className="mt-2 ">
                      <b>Actual amount </b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>CGST 9%</b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>SGST 9%</b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>Total GST 18% </b>{" "}
                    </div>
                    <div className="mt-2 mb-2">
                      <b>Total amount </b>{" "}
                    </div>
                  </div>
                  <div className="col-sm-1">
                    <div className="mt-2 ">
                      <b>: </b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>: </b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>: </b>{" "}
                    </div>
                    <div className="mt-2">
                      <b>: </b>{" "}
                    </div>
                    <div className="mt-2 mb-2">
                      <b> : </b>{" "}
                    </div>
                  </div>

                  <div className="col-sm-3">
                    <div className="mt-2">
                      ₹ {formData.actualAmount.toLocaleString("en-IN")}
                    </div>
                    <div className="mt-2">
                      ₹ {formData.cgst.toLocaleString("en-IN")}
                    </div>
                    <div className="mt-2">
                      ₹ {formData.sgst.toLocaleString("en-IN")}
                    </div>
                    <div className="mt-2">
                      ₹ {formData.gst.toLocaleString("en-IN")}
                    </div>
                    <div className="mt-2 mb-2">
                      ₹{" "}
                      {Math.floor(formData.totalAmount).toLocaleString("en-IN")}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {step === 1 && (
            <div className="mt-2">
              <div className="row">
                <div className="col-sm-12">
                  <TextField
                    label="Due Date From"
                    name="dueDateFrom"
                    type="date"
                    value={formData.dueDateFrom}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.dueDateFrom}
                    helperText={errors.dueDateFrom}
                  />
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Due Date From"
                      value={formData.dueDateFrom}
                      onChange={(newValue) =>
                        handleChange(newValue, "dueDateFrom")
                      }
                      slotProps={{
                        textField: {
                          error: !!errors.dueDateFrom,
                          helperText: errors.dueDateFrom,
                        },
                      }}
                      margin="normal"
                    />
                  </LocalizationProvider> */}
                </div>
                <div className="col-sm-12">
                  {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Due Date To"
                      value={formData.dueDateTo}
                      onChange={(newValue) =>
                        handleChange(newValue, "dueDateTo")
                      }
                      slotProps={{
                        textField: {
                          error: !!errors.dueDateTo,
                          helperText: errors.dueDateTo,
                        },
                      }}
                      margin="normal"
                    />
                  </LocalizationProvider>{" "} */}
                  <TextField
                    label="Due Date To"
                    name="dueDateTo"
                    type="date"
                    value={formData.dueDateTo}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ shrink: true }}
                    error={!!errors.dueDateTo}
                    helperText={errors.dueDateTo}
                  />{" "}
                </div>
              </div>
              <div className="row">
                {/* <div className="col-sm-6">
                  {" "}
                  <TextField
                    label="Invoice Number"
                    name="invoiceNumber"
                    value={formData.invoiceNumber}
                    onChange={handleChange}
                    fullWidth
                    margin="normal"
                    error={!!errors.invoiceNumber}
                    helperText={errors.invoiceNumber}
                  />
                </div> */}
              </div>
            </div>
          )}
        </div>

        <Box className={`mt-5 ${style.Buttons}`}>
          {step === 1 && (
            <Button
              variant="contained"
              onClick={handleNext}
              color="success"
              disabled={isButtonDisabled}
            >
              Next
            </Button>
          )}
        </Box>
        <div>
          {step === 2 && (
            <>
              <div className={`${style.Buttons2}`}>
                <div>
                  <Button
                    color="success"
                    variant="outlined"
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                </div>
                <div>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handlePreviewOpen}
                    disabled={isEditing ? !enableSubmit : enableSubmit}
                  >
                    Preview
                  </Button>
                </div>
                {/* <div>
                  <Button
                    variant="contained"
                    color="success"
                    onClick={handleConfirmationSubmit}
                    disabled={isEditing ? !enableSubmit : enableSubmit}
                  >
                    Submit
                  </Button>
                </div> */}
              </div>
            </>
          )}
        </div>
      </div>

      {successTick.save && (
        <MyModal>
          <ModalContainer
            zIndex={10002}
            childComponent={<SuccessTick HeadText={"Successfully saved"} />}
          />
        </MyModal>
      )}
      {successTick.create && (
        <MyModal>
          <ModalContainer
            zIndex={10004}
            childComponent={<SuccessTick HeadText={"Successfully"} />}
          />
        </MyModal>
      )}
      {openConfirmation.save && (
        <MyModal>
          <ModalContainer
            zIndex={10002}
            childComponent={
              <>
                <div>
                  <p>Are you sure you want to update the data ? </p>
                  <div className="d-flex justify-content-end gap-2 align-items-center">
                    <button
                      className="btn btn-danger"
                      onClick={() => setopenConfirmation({ save: false })}
                    >
                      No
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={handleSave}
                      disabled={enableSubmit}
                    >
                      Sure
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
      {openConfirmation.create && (
        <MyModal>
          <ModalContainer
            zIndex={10004}
            childComponent={
              <>
                <div>
                  <p>Do you confirm the creation of this invoice?</p>
                  <div className="d-flex justify-content-end gap-2 align-items-center">
                    <button
                      className="btn btn-danger"
                      onClick={() => setopenConfirmation({ create: false })}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-success"
                      onClick={handleSubmit}
                      disabled={enableSubmit}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
      {showField && (
        <MyModal>
          <ModalContainer
            zIndex={10002}
            childComponent={
              <>
                <div className="" style={{ width: "300px" }}>
                  <div className="row">
                    <div className="text-center ">
                      <b>Add Field</b>
                    </div>
                    <div className="col-sm-12">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={visibleFields.employeeId}
                            onChange={() => handleFieldToggle("employeeId")}
                          />
                        }
                        label="Employee ID"
                      />
                    </div>

                    <div className="col-sm-12">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={visibleFields.department}
                            onChange={() => handleFieldToggle("department")}
                          />
                        }
                        label="Department"
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-end align-items-center gap-2">
                    <button
                      className="btn btn-danger "
                      onClick={() => {
                        setShowField(false);
                        // setVisibleFields({
                        //   department: false,
                        //   employeeId: false,
                        // });
                      }}
                    >
                      Close
                    </button>
                    <button
                      className="btn btn-success "
                      onClick={() => {
                        setShowField(false);
                      }}
                    >
                      Ok
                    </button>
                  </div>
                </div>
              </>
            }
          />
        </MyModal>
      )}
      {openPreview && (
        <>
          <MyModal>
            <ModalContainer
              zIndex={10003}
              childComponent={
                <>
                  <div className="d-flex justify-content-between">
                    <div>
                      <b>Invoice Preview</b>
                    </div>
                    <div
                      onClick={() => {
                        setOpenPreview(false);
                      }}
                      className="btn btn-danger "
                    >
                      <AiOutlineClose />
                    </div>
                  </div>
                  <div
                    style={{
                      width: "900px",
                      height: "70vh",
                      overflowY: "auto",
                      // overflowX: "hidden",
                    }}
                  >
                    <Document
                      ref={documentRef}
                      data={formData}
                      empId={empId}
                      invoiceNumber={invoiceNumber}
                    />
                  </div>
                  <div>
                    <div className="d-flex justify-content-end">
                      <div>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={handleConfirmationSubmit}
                          disabled={enableSubmit}
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              }
            />
          </MyModal>
        </>
      )}
    </>
  );
}

export default InvoicePostForm;
